const Theme = {
  card_background_color: '#000',
  logo_image_url: 'YQB_bilingue_CMYK.jpg',
  header_full_height: true,
  token_hidden: true,
  number_hidden: true,

  body_background_color: '#fff',
  font_color: '#fff',
  number_color: '#fff',
  text_color: '#fff',
  title_color: '#fff',

  text_font: `'WayfindingSansRg', sans-serif`,

  title_font: `'WayfindingSansRg', sans-serif`,

  button_color: '#fedf00',
  button_text_color: '#000',
  button_radius: 50,

  footer_border_color: '#eee',
  footer_text_color: '#fff',

  legend_color: '#fff',
}

export default Theme
